import * as d3 from "d3";

export const chevronRightIcon = (
  x: number,
  y: number,
  svg: any,
  size: number,
  onClick: () => void,
  color: string
) => {
  const graphics = [];

  graphics.push(
    // Wrapper rectangle
    svg
      .append("rect")
      .attr("x", x - 1)
      .attr("y", y - 1)
      .attr("width", size + 2)
      .attr("height", size + 2)
      .attr("fill", "transparent")
      .style("cursor", "pointer")
  );
  graphics.push(
    // Downward line
    svg
      .append("path")
      .attr(
        "d",
        d3.line()([
          [x + size / 4, y],
          [x + (3 * size) / 4, y + size / 2],
          [x + size / 4, y + size],
        ])
      )
      .attr("stroke", color)
      .attr("stroke-width", 2)
      .attr("marker-start", "url(#arrow)")
      .attr("marker-end", "url(#arrow)")
      .attr("fill", "none")
  );
  graphics.forEach((g) => {
    g.on("click", function () {
      onClick();
    });
  });
};

export const chevronDownIcon = (
  x: number,
  y: number,
  svg: any,
  size: number,
  onClick: () => void,
  color: string
) => {
  const graphics = [];

  graphics.push(
    // Wrapper rectangle
    svg
      .append("rect")
      .attr("x", x - 1)
      .attr("y", y - 1)
      .attr("width", size + 2)
      .attr("height", size + 2)
      .attr("fill", "transparent")
      .style("cursor", "pointer")
  );
  graphics.push(
    // Downward line
    svg
      .append("path")
      .attr(
        "d",
        d3.line()([
          [x, y + size / 4],
          [x + size / 2, y + (3 * size) / 4],
          [x + size, y + size / 4],
        ])
      )
      .attr("stroke", color)
      .attr("stroke-width", 2)
      .attr("marker-start", "url(#arrow)")
      .attr("marker-end", "url(#arrow)")
      .attr("fill", "none")
  );
  graphics.forEach((g) => {
    g.on("click", function () {
      onClick();
    });
  });
};

export const errorIcon = (
  x: number,
  y: number,
  svg: any,
  size: number,
  tooltip?: string
) => {
  const color = "#EF4444";
  const group = svg.append("g").attr("class", "error-icon");

   // show tooltip message if it exists
  if (tooltip) {
    group.append("title").text(tooltip);
  }

  // hover area
  group.append("rect")
    .attr("x", x)
    .attr("y", y)
    .attr("width", size)
    .attr("height", size)
    .attr("fill", "transparent")
    .style("cursor", "pointer");

  group.append("circle")
    .attr("cx", x + size / 2)
    .attr("cy", y + size / 2)
    .attr("r", size / 2)
    .attr("fill", "transparent")
    .attr("stroke", color)
    .attr("stroke-width", 1.2);

  group.append("line")
    .attr("x1", x + size * 0.3)
    .attr("y1", y + size * 0.3)
    .attr("x2", x + size * 0.7)
    .attr("y2", y + size * 0.7)
    .attr("stroke", color)
    .attr("stroke-width", 1.2);

  group.append("line")
    .attr("x1", x + size * 0.7)
    .attr("y1", y + size * 0.3)
    .attr("x2", x + size * 0.3)
    .attr("y2", y + size * 0.7)
    .attr("stroke", color)
    .attr("stroke-width", 1.2);
};
